module.exports = __webpack_public_path__ + "img/mailed-statements-empty.e82d7c8b.png";